<div class="code-generation code-generation{{ wdgHeight }} d-flex flex-column" [ngClass]="{ 'with-bg': data.action !== 'share' }">
    <i
        class="btn-close icon-edponline-Bop-071"
        [ngClass]="{ 'pt-3-sa': isApp }"
        *ngIf="data.showClose"
        data-modal="dismiss()"
        (click)="dismissModal(false)"
        aria-hidden="true"
    ></i>
    <ng-container *ngIf="!errorGenerated">
        <!-- DEFAULT FORM -->
        <ng-container *ngIf="codeGenerated && data.action === 'share'">
            <div class="title text-center mt-md-4">{{ "pt.edp.edponline.widget.code.generation.modal.titleGenerated" | translate  }}</div>

            <span class="subtitle text-center mt-3" [class.mt-3]="data.collection.subTitle">
                {{ "pt.edp.edponline.widget.code.generation.modal.codeGeneratedWithSuccess" | translate }}
            </span>

            <span class="expiration-date my-3 text-center">
                {{ "pt.edp.edponline.widget.code.generation.modal.codeValidity" | translate }}
                <br />
                {{ "pt.edp.edponline.widget.code.generation.modal.promotionalTo" | translate }}
                <b>{{ getPartnerName() }}</b>
                {{ "pt.edp.edponline.widget.code.generation.modal.expiresAt" | translate }}
                <b>{{ codeValidation }}.</b>
            </span>

            <!-- <span class="heading-2 text-center text-uppercase">
                {{ "pt.edp.edponline.widget.code.generation.modal.promotionCode" | translate }}
            </span> -->

            <div class="d-flex justify-content-center align-items-center mt-3">
                <span class="sub-heading-2 text-center">{{ code }}</span>
                <i class="icon-edponline-Bop-138 code-generation-copy" (click)="copyCode(code)" *ngIf="showCopyCode"></i>
            </div>

            <div class="howto text-center" *ngIf="codeGenerated">
                <a [href]="sanitizeUrl(card.howToUseCode)" target="_blank" (click)="setHowToClick(card)">
                    {{ "pt.edp.edponline.benefits.howToUse" | translate }}
                    <i class="icon-edponline-Bop-135"></i>
                </a>
            </div>

            <!-- SUCCESS FORM -->
            <form [formGroup]="sucessForm" class="pb-0 pb-md-3">
                <div class="d-md-flex form-2-buttons mt-3">
                    <div class="input-container fluid mb-2 m-md-2">
                        <label class="text-label">{{ "pt.edp.edponline.modal.email" | translate }}</label>
                        <input
                            type="text"
                            class="form-control"
                            formControlName="email"
                            (change)="validateEmail()"
                            [ngClass]="{ error: showEmailError }"
                        />
                        <button
                            type="button"
                            class="btn mt-3 w-100 d-none d-md-block"
                            [class.btn-primary]="emailButtonStatus === 'initialState'"
                            [class.edp-btn-success]="emailButtonStatus === 'success'"
                            [class.btn-outline-danger]="emailButtonStatus === 'error'"
                            (click)="sendCodes(true)"
                            [innerHTML]="emailButtonMsg | translate"
                            [ngClass]="{ disabled: sucessForm.controls.email.invalid || sucessForm.controls.email.value === '' }"
                        ></button>
                    </div>

                    <div class="input-container fluid mb-2 m-md-2">
                        <label class="text-label text-capitalize">{{ "pt.edp.edponline.PhoneNumber" | translate }}</label>
                        <input
                            type="number"
                            class="form-control"
                            formControlName="phoneNumber"
                            (change)="validatePhoneNumber()"
                            maxlength="9"
                            [ngClass]="{ error: showPhoneError }"
                        />
                        <button
                            type="button"
                            class="btn mt-3 w-100 d-block d-md-none"
                            [class.btn-primary]="emailButtonStatus === 'initialState'"
                            [class.edp-btn-success]="emailButtonStatus === 'success'"
                            [class.btn-outline-danger]="emailButtonStatus === 'error'"
                            (click)="sendCodes(true)"
                            [innerHTML]="emailButtonMsg | translate"
                            [ngClass]="{ disabled: sucessForm.controls.email.invalid || sucessForm.controls.email.value === '' }"
                        ></button>
                        <button
                            type="button"
                            class="btn mt-3 w-100"
                            [class.btn-primary]="!smsSent"
                            [class.btn-primary]="smsButtonStatus === 'initialState'"
                            [class.edp-btn-success]="smsButtonStatus === 'success'"
                            [class.btn-outline-danger]="smsButtonStatus === 'error'"
                            (click)="sendCodes(false)"
                            [innerHTML]="smsButtonMsg | translate"
                            [ngClass]="{ disabled: sucessForm.controls.phoneNumber.invalid || !sucessForm.controls.phoneNumber.value }"
                        ></button>
                    </div>
                </div>
            </form>

            <ng-container *ngIf="codeGenerated">
                <div
                    class="text-center cta pt-2 font-weight-bold cursor-pointer"
                    card-modal="dismiss()"
                    [routerLink]="benefits.route"
                    [queryParams]="benefits.param"
                    (click)="onClickLink(benefits)"
                >
                    {{ "pt.edp.edponline.widget.partner.discount.link" | translate }}
                    <i class="ml-wdgt-2 icon-edponline-Bop-073 rotate-270" [ngStyle]="{ 'margin-top': '-0.3rem' }" aria-hidden="true"></i>
                </div>
            </ng-container>
        </ng-container>

        <edp-loader [size]="'full'" [position]="'center'" class="text-center" *ngIf="!multiCodesLoaded"></edp-loader>
        <ng-container *ngIf="data.action !== 'share' && multiCodesLoaded">
            <ng-container *ngIf="!multiCodePartner">
                <div class="partner-info">
                    <div class="text-container">
                        <div class="title mt-1 mt-md-0">{{ card.activityTitle }}</div>

                        <div class="sub-heading-1 text-2" [innerHTML]="card.description"></div>

                        <div class="text text-4" [innerHTML]="card.activityDescription"></div>

                        <div class="second-title mt-4">{{ card.name }}</div>

                        <div class="text text-3" [innerHTML]="card.partnerDescription"></div>

                        <div class="know-more">
                            <a [href]="sanitizeUrl(card.partnerLink)" target="_blank"
                                [gaClickDatalayer]="'clickOpenLink'"
                                [extraGaClickDatalayer]="getGaClickData(card)"
                            >
                            {{ "pt.edp.edponline.benefits.partnerLink" | translate }}
                        </a>
                    </div>

                        <div
                            class="d-flex mt-4 custom-select-list-container"
                            *ngIf="(card.partners && card.partners.length > 0) || (card.options && card.options.length > 0)"
                        >
                            <div class="custom-select-list" role="group" ngbDropdown>
                                <div class="edp-selected" ngbDropdownToggle>
                                    <input
                                        autofocus="false"
                                        type="text"
                                        class="custom-form-control dropdown-input"
                                        [value]="dropdownFormControl.controls['dropdown']?.value | translate"
                                        placeholder="{{ 'pt.edp.edponline.select_list.search' | translate }}"
                                        readonly
                                    />
                                    <span class="select-icon">
                                        <i class="icon icon-edponline-Bop-073" aria-hidden="true"></i>
                                    </span>
                                </div>
                                <ul class="select-list" ngbDropdownMenu>
                                    <hr />
                                    <li
                                        *ngFor="let item of edpList; index as i"
                                        class="select-item"
                                        ngbDropdownItem
                                        (click)="
                                            onSelectListChange(item.value); dropdownFormControl.controls['dropdown'].setValue(item.text)
                                        "
                                    >
                                        {{ item.text | translate }}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="howto" *ngIf="codeGenerated">
                            <a [href]="sanitizeUrl(card.howToUseCode)" target="_blank" (click)="setHowToClick(card)">
                                {{ "pt.edp.edponline.benefits.howToUse" | translate }}
                                <i class="icon-edponline-Bop-135"></i>
                            </a>
                        </div>
                    </div>
                    <div class="img-container">
                        <img src="{{ card.image }}" alt="" />
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="multiCodePartner">
                <span class="title text-left mt-md-1">
                    {{
                        (allMultiCodesGenerated
                            ? "pt.edp.edponline.widget.code.generation.modal.multicodes.generatedCodes"
                            : "pt.edp.edponline.widget.code.generation.modal.multicodes.title"
                        ) | translate
                    }}
                    {{ card.name }}
                </span>
                <div
                    class="cta-multi-codes my-3"
                    [innerHTML]="'pt.edp.edponline.widget.code.generation.modal.multicodes.cta' | translate"
                ></div>
                <code-generation-multi-codes
                    [multiCodes]="multiCodes"
                    [appliedConditions]="appliedConditions"
                ></code-generation-multi-codes>
            </ng-container>

            <div class="condition-terms without-form mt-4 text-center text-md-left" *ngIf="codeGenerated">
                <a (click)="openTermsModal($event)">{{ "pt.edp.edponline.benefits.termsAndConditions" | translate }}</a>
            </div>

            <form
                *ngIf="(!multiCodePartner || (multiCodePartner && !allMultiCodesGenerated)) && !codeGenerated"
                class="edp-form d-flex flex-column mb-3 pt-3"
            >
                <div class="form-group mb-4">
                    <label class="form-check-label pl-5">
                        <span class="condition-terms">
                            {{ "Register.terms1" | translate }}
                            <a (click)="openTermsModal($event)">{{ "pt.edp.edponline.benefits.termsAndConditions" | translate }}</a>
                            <!-- {{ "pt.edp.edponline.widget.code.generation.modal.conditionTerms" | translate }} -->
                        </span>
                        <input class="form-check-input" type="checkbox" id="form-terms" (change)="onClick($event)" />
                        <span class="form-check-mark"></span>
                    </label>
                </div>

                <button
                    impersonateDisable
                    class="btn btn-primary submit-button"
                    type="button"
                    [disabled]="!canGenerateCode"
                    (click)="getCode()"
                >
                    {{ "pt.edp.edponline.widget.code.generation.modal.generateCode" | translate }}
                </button>
            </form>
        </ng-container>
    </ng-container>

    <!-- ERROR FORM -->
    <div *ngIf="errorGenerated" class="error-container align-items-center d-flex flex-column">
        <span><i class="error-icon icon-edponline-Bra-025" aria-hidden="true"></i></span>
        <span class="error-title mt-4">{{ "pt.edp.edponline.widget.code.generation.modal.errorGeneratingCode" | translate }}</span>
        <span class="error-subtitle mt-3">{{ "pt.edp.edponline.widget.code.generation.modal.errorGeneratingCode_sub" | translate }}</span>
        <button
            impersonateDisable
            class="btn btn-primary w-75 mt-5"
            type="button"
            [disabled]="!canGenerateCode"
            (click)="getCode()"
        >
            {{ "pt.edp.edponline.widget.code.generation.modal.tryAgain" | translate }}
        </button>
    </div>
</div>
